module.exports = __webpack_public_path__ + "static/media/pool-skimmer-image-4.b98e547f.jpg";